import Grid from '@mui/material/Grid'
import WbSwitch from '../../../components/common/WbSwitch'
import FormControlLabel from '@mui/material/FormControlLabel'
import {Autocomplete, Chip, FormControl, TextField} from '@mui/material'
import {getApiHookParams} from '../../../auth'

export default function SelectSchool({
  participantFilter,
  setParticipantFilter,
  schools,
}) {
  const apiParams = getApiHookParams()
  return (
    !participantFilter?.all &&
    apiParams.groupId > 0 &&
    apiParams.schoolId === null && (
      <div>
        <Grid container>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <FormControlLabel
              control={
                <WbSwitch
                  size="small"
                  checked={participantFilter?.allSchools}
                  onChange={e => {
                    let val = {
                      ...participantFilter,
                      allSchools: e.target.checked,
                      schoolId:
                        e.target.checked === true
                          ? [...schools.map(school => school.id)]
                          : [],
                    }
                    setParticipantFilter(val)
                  }}
                ></WbSwitch>
              }
              label={'All Schools'}
            ></FormControlLabel>
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <FormControl
              fullWidth
              style={{
                display: participantFilter?.allSchools ? 'none' : 'block',
                marginTop: '10px',
              }}
            >
              <Autocomplete
                multiple
                disableCloseOnSelect
                disabled={participantFilter?.allSchools}
                options={schools}
                getOptionLabel={option => option.name ?? ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                value={schools.filter(s =>
                  (participantFilter?.schoolId ?? []).includes(s.id)
                )}
                onChange={(e, vals) => {
                  let val = {
                    ...participantFilter,
                    schoolId: vals.map(v => v.id),
                  }
                  setParticipantFilter(val)
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, i) => (
                    <Chip
                      {...getTagProps({index: i})}
                      key={option.id}
                      label={option.name}
                    />
                  ))
                }
                renderInput={params => (
                  <TextField {...params} label="Select Schools" size="small" />
                )}
              />
            </FormControl>
          </Grid>
        </Grid>
      </div>
    )
  )
}
